<template>
 
  <div>
    <label  for="season"><strong>STAGIONE</strong>    
    </label>
   <!--
    <a href="#" @click="reset()" class="btn btn-light btn-sm ml-3">
      <i style="color:brown" class="fas fa-sync" aria-hidden="true"></i>
    </a>  
  -->
    <div class="input-group_">  
    <v-select

   
    
    :searchable="true" multiple  :clearable="false" :loading="loading"  @input="setData"  :options="options" v-model="selected" :reduce="season => season.seasonId" label="season">
    
    <template #search="{attributes, events}">
    <input
      class     = "vs__search"
    
      
     :required = "props.required && !selected"
      v-bind    = "attributes"
      v-on      = "events"
      
    />
    </template>

      
      <template #selected-option="{season}">
  
      <div style="display: flex; align-items: baseline">
        <strong>{{ season }}</strong>          
      </div>

    </template>
  
 
    </v-select>

   
    </div>

    
  </div>
</template>


<script>


import api     from "@/api"
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import {mapGetters }   from 'vuex'


export default {
props: ['props'],
components: { vSelect },
data() {
    return {

        
        selected : null,
        options  : [],
        loading  : false,
       

        

    
        
    };
  },
computed: {
  ...mapGetters(['company']) 
  },
mounted: function () {
  
  this.getData()
  
},
  
methods: {
   
    required() 
    {
     return this.props.required
    },
    
  
  /*
  reset()
  {
    this.selected = []
    this.$emit("update", []);
 
  },
  */
  setData(seasonId)
  {
   
    let text = ''
    const arr = seasonId.toString().split(',')            
    arr.forEach(item => {
       
      this.options.forEach(option =>{
        if(option.seasonId == item)
        {
          text +=  option.season + '-'
          
        }
        
      })
      

    })
    
    
    
    if(seasonId.length == 0)
    {
      this.selected = null
    }
    this.$emit("update", seasonId,text);
  },
  async getData()
    {            
      
      this.loading = true  
      let sp       = {'sp'        : 'spSeasonSelect'}
      //let data     = {'companyId' : this.company.Id}
      //let json     = Object.assign(data, sp);  

      await api.post(sp).then(res => {
            if(res.status==200)
            {
                
                const options = res.data.recordsets[0]

                this.options  = options
                if(this.props.selection.length > 0)
                {
                  this.selected = this.props.selection
                } 
                
                

                      
            }
           else if(res.status==500)
           {
                console.log(res.data)

            } 
          else
            {
                console.log('Network Error.')                  
                 
            } 
      
      

          }).catch(err => {
              
              console.log(err.message)    

              
          }).finally(() => {
            this.loading = false
        });

    

    },
  

}
}
</script>

<style scoped >
h4 {
  font-family: 'Roboto Condensed';
  /*font-size: 16px;*/
}

</style>
